import { useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import Coverage from "@/components/Coverage";
import BookingForm from "@/components/BookingForm";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { useLenis } from "@/hooks/useLenis";

export default function Landing() {
    useLenis();
    const [preselectedService, setPreselectedService] = useState("");

    return (
        <div className="bg-[#060709] text-white min-h-screen" data-testid="landing-page">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Services onBook={setPreselectedService} />
                <HowItWorks />
                <Coverage />
                <BookingForm preselectedService={preselectedService} />
                <Testimonials />
            </main>
            <Footer />
            <WhatsAppButton />
        </div>
    );
}
